let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1xx1S")).then(() => parcelRequire('4gPTd'));